import React, { useMemo } from "react";

import { Elements } from "@stripe/react-stripe-js";

import { stripePromise } from "../../hooks/usePaymentMethods";

const StripeWrapper = ({children,options = {},}) => {
  const stripeOptions = useMemo(() => ({
    ...options,
    }),
    [options]
  );

  return (
    <Elements
      stripe={stripePromise}
      options={stripeOptions}
    >
      {children}
    </Elements>
  );
};

export default React.memo(StripeWrapper);